import { hostname } from '../../../../utils/env';
import * as manageMembershipStyles from './ManageMembership.module.css';

interface ManageMembershipLinkProps {
  path?: string;
  title: string;
  subtitle: string;
  onClickCTA?: () => void;
  isButton?: boolean;
}

const ManageMembershipLink = ({
  path,
  title,
  subtitle,
  onClickCTA,
  isButton = false,
}: ManageMembershipLinkProps) => {
  return isButton ? (
    <button
      onClick={onClickCTA}
      className={`${manageMembershipStyles.linkContainer}`}
      data-testid={`${title}-button`}
    >
      <p className={`${manageMembershipStyles.linkTitle}`}>{title}</p>
      <p className={`${manageMembershipStyles.linkSubTitle}`}>{subtitle}</p>
    </button>
  ) : (
    <a
      href={`https://${hostname}${path}`}
      onClick={onClickCTA}
      className={`${manageMembershipStyles.linkContainer}`}
      data-testid={`${title}-link`}
    >
      <p className={`${manageMembershipStyles.linkTitle}`}>{title}</p>
      <p className={`${manageMembershipStyles.linkSubTitle}`}>{subtitle}</p>
    </a>
  );
};

export default ManageMembershipLink;
